"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindImagePaste = void 0;
const slate_react_1 = require("slate-react");
const json_crdt_1 = require("json-joy/lib/json-crdt");
const file_1 = require("./file");
/**
 * Patches `editor.insertData` so that pasting one or more images (e.g. a
 * screenshot from the clipboard) inserts `file` void blocks instead of
 * falling through to Slate's default HTML/text paste logic.
 */
const bindImagePaste = (state) => {
    const editor = state.editor;
    const prev = editor.insertData;
    editor.insertData = (data) => {
        const images = collectImageFiles(data);
        if (images.length)
            void pasteImages(state, images);
        else
            prev?.call(editor, data);
    };
};
exports.bindImagePaste = bindImagePaste;
const collectImageFiles = (data) => {
    const fromFiles = Array.from(data.files).filter((f) => f.type.startsWith('image/'));
    if (fromFiles.length)
        return fromFiles;
    return Array.from(data.items ?? [])
        .filter((item) => item.type.startsWith('image/'))
        .map((item) => item.getAsFile())
        .filter((f) => f !== null);
};
const pasteImages = async (state, files) => {
    for (const file of files) {
        const bytes = new Uint8Array(await file.arrayBuffer());
        const id = state.things.add({
            '@type': 'file',
            name: file.name || `image-${Date.now()}.png`,
            mimeType: file.type || 'image/png',
            size: file.size,
            data: json_crdt_1.s.con(bytes),
        });
        if (!state.editor.selection)
            try {
                slate_react_1.ReactEditor.focus(state.editor);
            }
            catch { }
        (0, file_1.insertFile)(state.editor, id);
        state.sync(true);
    }
};
